import { useQuery } from '@tanstack/react-query'
import { message } from 'antd'
import { get } from 'lodash'
import moment from 'moment'
import { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import Layout from '@components/Layout'
import ConfirmExitModal from '@components/Modal/ConfirmExitModal/index'
import CreteCustomerModal from '@components/Modal/createCustomerModal'
import ErrorModal from '@components/Modal/ErrorModal'
import SuccessModal from '@components/Modal/SuccessModal'
import ViewDepartmentsBalanceModal from '@components/Modal/viewDepartmentsBalanceModal'
import WarningModal from '@components/Modal/WarningModal/index'
import { http } from '@services/http'
import { calculateKvm } from '@utils/calculateKvm'
import {
	calculateTotalWithKoef,
	calculateLineTotal,
} from '@utils/calculations'
import { debouncedSet } from '@utils/debounce'
import { catchError } from '@utils/errrorHandling'
import {
	fetchClientsSelect,
	fetchDepartments,
	fetchSalesPerson,
	fetchWarehouse,
	fetchPackageServicesNoPagination,
	fetchShapeItemsWithPrices,
} from '@utils/fetchData'
import { generateImage } from '@utils/generateShapeImage'
import {
	calculateShtPrices,
	calculateMetrPriceServices,
	calculateMetrPriceParametr,
	calculateKvmPrices,
	calculateSelectedServicesRowTotal,
	circleServiceQuantity,
	perimeterQuantity,
} from '@utils/salesOrderCalculations'

import ClientOrderInfoSection from './components/ClientOrderInfoSection'
import FormActions from './components/FormActions'
import ImageUploadSection from './components/ImageUploadSection'
import OrderTotalsSection from './components/OrderTotalsSection'
import SalesItemsTable from './components/SalesItemsTable'
import ServicesModal from './components/ServicesModal'
import SummaryTable from './components/SummaryTable'

// This is the hardest screen in our project and I know that i have to optimize my codes in this page when i will be free i will do it

const CreateSales = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const successRef = useRef()
	const errorRef = useRef()
	const warningRef = useRef()

	const { roleNames, getMe, slpCode, department } = useSelector(
		(state) => state.main,
	)

	const isAdmin = roleNames.includes('admin')

	const [defaultService, setDefaultService] = useState({})

	const [clientCode, setClientCode] = useState('')
	const [clientName, setClientName] = useState('')
	const [searchClientName, setSearchClientName] = useState('')
	const [searchItemName, setSearchItemName] = useState('')
	const [date, setDate] = useState('')
	const [currency, setCurrency] = useState('UZS')
	const [comments, setComments] = useState('')
	const [sendFile, setSendFile] = useState(false)
	const [imageList, setImageList] = useState([
		{ file: null, path: '', imgLoading: false },
	])
	const [whs, setWhs] = useState(get(getMe, 'u_WareHouse', ''))
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false)
	const [isViewBpBalanceModalVisible, setIsViewBpBalanceModalVisible] =
		useState(false)
	const [btnLoading, setIsBtnLoading] = useState(false)
	const [isDiscountBigger, setIsDiscountBigger] = useState(false)
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [selectedServices, setSelectedServices] = useState([])
	const [currentRecord, setCurrentRecord] = useState(null)
	const [departmentAdmin, setDepartmentAdmin] = useState(department)
	const [slpAdmin, setSlpAdmin] = useState(get(getMe, 'salesPersonCode', ''))
	const [dateSale, setDateSale] = useState(moment().format('YYYY-MM-DD'))
	const [bpDebt, setBpDebt] = useState('')
	const [inputDocTotal, setInputDocTotal] = useState(0)
	const [tableData, setTableData] = useState([
		{
			key: '1',
			itemCode: null,
			itemName: null,
			width: '',
			height: '',
			quantity: '',
			ugpName: '',
			price: '',
			currency: currency,
			lineTotal: '',
			lineNum: 0,
			u_Timer: '',
			disabled: false,
			koefitsent: 1,
			selectedServices: [],
			amountInWhs: 0,
			itemType: 'Item',
		},
	])
	const [expensesItems, setExpensesItems] = useState([])

	const [inputDateCount, setInputDateCount] = useState('')

	const docTotal = tableData.reduce((acc, row) => {
		const koef = row.koefitsent || 1

		const selectedPrices = calculateSelectedServicesRowTotal(row)

		const shtPrices = calculateShtPrices(row?.selectedServices)

		const metrPricesServices = calculateMetrPriceServices(
			row?.selectedServices,
		)

		const metrPricesParametr = calculateMetrPriceParametr(
			row?.selectedServices,
		)

		const totalWithKoef = calculateTotalWithKoef(
			row.width,
			row.height,
			row.quantity,
			koef,
		)

		return (
			acc +
			(calculateLineTotal(row.price, 0, totalWithKoef || 0) +
				(shtPrices || 0) +
				(selectedPrices || 0) +
				(metrPricesServices || 0) +
				(metrPricesParametr || 0))
		)
	}, 0)

	const totalKvm = new Intl.NumberFormat().format(
		tableData.reduce(
			(acc, row) =>
				acc +
				parseFloat(row.quantity * calculateKvm(row.width, row.height)),
			0,
		),
	)

	const sanitizeDocTotalValue = (rawValue) => {
		const sanitizedValue = rawValue
			.replace(/\s+/g, '')
			.replace(',', '.')

		return parseFloat(sanitizedValue) || 0
	}

	const handleDocTotalChange = (e) => {
		const value = sanitizeDocTotalValue(e.target.value)
		const originalDocTotal = Number(docTotal) || 0

		// if (!isAdmin && value < originalDocTotal) {
		// 	setInputDocTotal(originalDocTotal)
		// 	setIsDiscountBigger(false)
		// 	return
		// }

		setInputDocTotal(value)
if(!isAdmin) {
			setIsDiscountBigger(value < originalDocTotal)
}
	}

	const handleDocTotalBlur = (e) => {
		const value = sanitizeDocTotalValue(e.target.value)
		const originalDocTotal = Number(docTotal) || 0

		if (!isAdmin && value < originalDocTotal) {
			setInputDocTotal(originalDocTotal)
			setIsDiscountBigger(true)
			return
		}

		setInputDocTotal(value)
if(!isAdmin) {
			setIsDiscountBigger(value < originalDocTotal)
}
	}

	const arendaTotal = tableData?.reduce(
		(acc, row) => {
			const arendaItem = expensesItems?.find(
				(item) => item.itemCode?.toLowerCase() === 'arenda',
			)
			const koef = row.koefitsent || 1
			const totalWithKoef = calculateTotalWithKoef(
				row.width,
				row.height,
				row.quantity,
				1,
			)

			return {
				total: acc.total + totalWithKoef * (arendaItem?.price || 0),
				itemCode: arendaItem?.itemCode,
			}
		},
		{ total: 0, itemCode: '' },
	)

	const ishHaqiTotal = tableData?.reduce(
		(acc, row) => {
			const Ish_xaqqi = expensesItems?.find(
				(item) => item.itemCode?.toLowerCase() === 'ish_xaqqi',
			)
			const koef = row.koefitsent || 1
			const totalWithKoef = calculateTotalWithKoef(
				row.width,
				row.height,
				row.quantity,
				1,
			)
			return {
				total: acc.total + totalWithKoef * (Ish_xaqqi?.price || 0),
				itemCode: Ish_xaqqi?.itemCode,
			}
		},
		{ total: 0, itemCode: '' },
	)

	const elektrTotal = tableData?.reduce(
		(acc, row) => {
			const elektrItem = expensesItems?.find(
				(item) => item.itemCode?.toLowerCase() === 'elektr_xarajat',
			)

			console.log('selectedServices', row.selectedServices)

			const koef = row.koefitsent || 1

			const selectedPrices = calculateSelectedServicesRowTotal(
				row,
				'U_Elektr_rasxod',
			)

			const shtPrices = calculateShtPrices(
				row?.selectedServices,
				'U_Elektr_rasxod',
			)

			const metrPricesServices = calculateMetrPriceServices(
				row?.selectedServices,
				'U_Elektr_rasxod',
			)

			const metrPricesParametr = calculateMetrPriceParametr(
				row?.selectedServices,
				'U_Elektr_rasxod',
			)

			const lineTotal =
				(shtPrices || 0) +
				(selectedPrices || 0) +
				(metrPricesServices || 0) +
				(metrPricesParametr || 0)

			return {
				total: acc.total + lineTotal,
				itemCode: elektrItem?.itemCode,
			}
		},
		{ total: 0, itemCode: '' },
	)

	const stanokTotal = tableData?.reduce(
		(acc, row) => {
			const elektrItem = expensesItems?.find(
				(item) => item.itemCode?.toLowerCase() === 'stanokk_xarajat',
			)

			const koef = row.koefitsent || 1

			const selectedPrices = calculateSelectedServicesRowTotal(
				row,
				'U_Stanok_rasxod',
			)

			const shtPrices = calculateShtPrices(
				row?.selectedServices,
				'U_Stanok_rasxod',
			)

			const metrPricesServices = calculateMetrPriceServices(
				row?.selectedServices,
				'U_Stanok_rasxod',
			)

			const metrPricesParametr = calculateMetrPriceParametr(
				row?.selectedServices,
				'U_Stanok_rasxod',
			)

			const lineTotal =
				(shtPrices || 0) +
				(selectedPrices || 0) +
				(metrPricesServices || 0) +
				(metrPricesParametr || 0)

			return {
				total: acc.total + lineTotal,
				itemCode: elektrItem?.itemCode,
			}
		},
		{ total: 0, itemCode: '' },
	)

	const fetchItemsSelect = async ({ queryKey }) => {
		const [_, itemName, category, api] = queryKey
		try {
			const url = `${api}?itemName=${itemName}&category=${category}&pageToken=0&pageSize=10000`
			const { data } = await http.get(url)

			const formattedData = data.data.map((item) => ({
				...item,
				image: generateImage(item.itemCode),
			}))
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchExpensesItems = async ({ queryKey }) => {
		const [_, uModal] = queryKey
		try {
			const url = `api/items/get-items?modalService=${uModal}&pageToken=0&pageSize=100`
			const { data } = await http.get(url)

			const formattedData = data.data
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchRombikItems = () =>
		fetchShapeItemsWithPrices({
			tabType: 'Rombik',
			modalService: 'Rhombic_Figures',
		})

	const fetchTelefonItems = () =>
		fetchShapeItemsWithPrices({ modalService: 'Telefon' })

	const fetchKalitShapes = () =>
		fetchShapeItemsWithPrices({
			tabType: 'Kalit',
			modalService: 'Key_Figures',
		})

	const fetchBpBalance = async ({ queryKey }) => {
		const [, clientCode] = queryKey
		if (clientCode) {
			try {
				const url = `api/businesspartners/get-business-partners-balance?cardCode=${clientCode}`
				const { data } = await http.get(url)
				setBpDebt(
					data[0]?.departments?.reduce(
						(acc, item) => acc + item.balance,
						0,
					),
				) || 0
				return data
			} catch (error) {
				console.log(error)
			}
		}
	}

	const { data: packageServicesData = [] } = useQuery({
		queryKey: ['packageServices'],
		queryFn: fetchPackageServicesNoPagination,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: bpBalanceData = [] } = useQuery({
		queryKey: ['bpBalance', clientCode],
		queryFn: fetchBpBalance,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		enabled: !!clientCode,
	})

	const {
		data: clientsData = [],
		isLoading: loadingClient,
		refetch,
	} = useQuery({
		queryKey: [
			'clients',
			searchClientName,
			'50',
			'api/businesspartners/mijozlar',
		],
		queryFn: fetchClientsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: itemsData = [], isLoading: itemsLoading } = useQuery({
		queryKey: ['items', searchItemName, 'Окно', 'api/items/get-items'],
		queryFn: fetchItemsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: serviceItemsData = [] } = useQuery({
		// Bu toggleServicesCombinedni ichida ishlatilgan bu hamma uslugalarni olib keladi modalServicega bolmasdan
		queryKey: ['serviceItems', '', '', 'api/items/get-items'],
		queryFn: fetchItemsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: expensesItemsResData = [] } = useQuery({
		// Bu Xarajatlar uslugalarini olish uchun qilindi
		queryKey: ['expensesItems', 'Xarajatlar'],
		queryFn: fetchExpensesItems,
		keepPreviousData: false,
		refetchOnWindowFocus: false,
	})

	const { data: rombikItemsData = [] } = useQuery({
		queryKey: ['rombikItems'],
		queryFn: fetchRombikItems,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: telefonItemsData = [] } = useQuery({
		queryKey: ['telefonItems'],
		queryFn: fetchTelefonItems,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: kalitShapedData = [] } = useQuery({
		queryKey: ['kalitShapes'],
		queryFn: fetchKalitShapes,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: warehouseData = [], isLoading: whsLoading } = useQuery({
		queryKey: ['warehouses'],
		queryFn: fetchWarehouse,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: departmentData = [], isLoading: departmentLoading } =
		useQuery({
			queryKey: ['departments'],
			queryFn: fetchDepartments,
			keepPreviousData: true,
			refetchOnWindowFocus: false,
		})

	const { data: slpData = [], isLoading: slpLoading } = useQuery({
		queryKey: ['salesPerson'],
		queryFn: fetchSalesPerson,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	useEffect(() => {
		if (!serviceItemsData?.length || !tableData?.length) return

		const firstRow = tableData[0]

		if (!firstRow?.selectedServices) return

		const hasDelivery = firstRow.selectedServices.some(
			(item) => item.itemCode === 'delivery',
		)

		if (hasDelivery) return

		const deliveryItem = serviceItemsData.find(
			(item) => item.itemCode === 'delivery',
		)

		if (!deliveryItem) return

		const updatedTable = [...tableData]
		updatedTable[0] = {
			...updatedTable[0],
			selectedServices: [
				...updatedTable[0].selectedServices,
				{
					lineNum: updatedTable[0].selectedServices.length,
					...deliveryItem,
				},
			],
		}

		setDefaultService(deliveryItem)
		setTableData(updatedTable)
	}, [serviceItemsData])

	useEffect(() => {
		if (!expensesItemsResData?.length) return
		setExpensesItems(expensesItemsResData)
	}, [expensesItemsResData])

	const switchExpensePrice = (itemCode) => {
		switch (itemCode) {
			case arendaTotal?.itemCode:
				return arendaTotal?.total

			case stanokTotal?.itemCode:
				return stanokTotal?.total
			case ishHaqiTotal?.itemCode:
				return ishHaqiTotal?.total
			case elektrTotal?.itemCode:
				return elektrTotal?.total

			default:
				break
		}
	}

	const onSubmit = async () => {
		console.log('tableData = ', tableData)
		console.log('docTotal = ', docTotal, inputDocTotal,)

		const originalDocTotal = Number(docTotal) || 0

		if (!clientCode) return message.error('Клиент не выбран')
		if (!inputDocTotal) return message.error('Общая сумма не указана')
		if (!isAdmin && inputDocTotal < originalDocTotal) {
			setInputDocTotal(originalDocTotal)
			setIsDiscountBigger(false)
			return message.error('Общая сумма меньше суммы товаров')
		}
		if (!date) return message.error('Дата срока не выбрана')
		if (!currency) return message.error('Валюта не выбрана')
		if (!departmentAdmin) return message.error('Отдел не выбран')
		if (!slpAdmin) return message.error('Менеджер продаж не выбран')
		if (!whs) return message.error('Склад не выбран')
		if (!get(getMe, 'employeeId', ''))
			return message.error('EmployeeId не задан')
		if (tableData.length === 0) return message.error('Таблица пустая')
		if (tableData?.some((row) => !row.itemCode))
			return message.error('Товар не выбран')
		if (tableData?.some((row) => !row.koefitsent || row.koefitsent <= 0))
			return message.error('Коэффициент должен быть больше 0')

		const photoId = (imageList || [])
			.map((image) => image.path)
			.filter(Boolean)
			.join(',')

		setIsBtnLoading(true)

		try {
			let lineNumber = 0 // Initialize line number counter

			console.log('tableData = ', tableData)

			const totalItemsQuantity = tableData.reduce((total, row) => {
				return (
					total +
					Number(row.quantity) * +calculateKvm(row.width, row.height)
				)
			}, 0)
			const totalItemsPlannedQty = tableData.reduce((total, row) => {
				return (
					total +
					Number(row.quantity)
				)
			}, 0)

			console

			const data = {
				cardCode: clientCode,
				docDate: dateSale,
				docDueDate: date,
				docTotal: inputDocTotal,
				documentOwner: get(getMe, 'employeeId', ''),
				salesPersonCode: slpAdmin,
				comments: comments,
				u_ChertejId: photoId,
				docCurrency: currency,
				department: departmentAdmin,
				u_DueDays: inputDateCount,
				documentLines: [
					...(Array.isArray(tableData)
						? tableData.map((row) => ({
								lineNum: lineNumber++, // Increment line number
								itemCode: row.itemCode,
								quantity: Number(
									row.quantity *
										calculateKvm(row.width, row.height),
								),
								unitPrice:
									Number(row.price) * +(row.koefitsent || 1),
								currency: row.currency,
								warehouseCode: whs,
								u_uslugaID: Number(row.lineNum),
								u_Produkt: null,
								u_Kvmetr: calculateKvm(row.width, row.height),
								u_Width: row.width,
								u_Height: row.height,
								u_Coefficient: row.koefitsent,
								u_Timer: null,
								u_PlannedQuantity: row.quantity,
								u_Number: row.u_Number || '',
								u_ItemGroup: 'Item',
								u_FigureQuantity: 0,
								u_ShapeSides: '',
								u_SizeType: '',
								u_SharepeningType: '',
								u_ConnectedShape: '',
								u_Modal: '',
								discountPercent: 0,
								u_ProductionNumber: row.u_ProductionNumber,
								u_ElectricityCost:
									switchExpensePrice(elektrTotal?.itemCode) /
										+totalItemsQuantity || 0,
								u_MachineCost:
									switchExpensePrice(stanokTotal?.itemCode) /
										+totalItemsQuantity || 0,
							}))
						: []),
					...expensesItems?.map((row) => ({
						lineNum: lineNumber++, // Increment line number
						itemCode: row.itemCode,
						quantity:
							row.itemCode === elektrTotal.itemCode ||
							row.itemCode === stanokTotal.itemCode
								? 1
								: totalItemsQuantity,
						unitPrice: (
							switchExpensePrice(row.itemCode) /
							(row.itemCode === elektrTotal.itemCode ||
							row.itemCode === stanokTotal.itemCode
								? 1
								: +totalItemsQuantity)
						).toFixed(2),
						currency: row.currency,
						warehouseCode: whs,
						u_uslugaID: '-1',
						u_Produkt: '-1',
						u_Kvmetr: 1,
						u_Width: '1000',
						u_Height: '1000',
						u_Coefficient: 1,
						u_Timer: null,
						u_PlannedQuantity: row.itemCode === elektrTotal.itemCode ||
							row.itemCode === stanokTotal.itemCode ? totalItemsPlannedQty : totalItemsQuantity,// eski xolatida faqat  totalItemsQuantity ketardi  Bu logika orqaga qaytarilishi mumkun 30-iyuldigi  error uchun logika ozgartirildi
						u_Number: '',
						u_ItemGroup: 'Expenses',
						u_FigureQuantity: 0,
						u_ShapeSides: '',
						u_SizeType: '',
						u_SharepeningType: '',
						u_ConnectedShape: '',
						u_Modal: 'Xarajatlar',
						discountPercent: 100,
						u_ProductionNumber: '',
						u_ElectricityCost:
							switchExpensePrice(elektrTotal?.itemCode) /
								+totalItemsQuantity || 0,
						u_MachineCost:
							switchExpensePrice(stanokTotal?.itemCode) /
								+totalItemsQuantity || 0,
					})),
					...(Array.isArray(tableData)
						? tableData
								.filter((row) =>
									Array.isArray(row.selectedServices),
								)
								.flatMap((row) =>
									row.selectedServices.map((service) => ({
										lineNum: lineNumber++, // Increment line number
										itemCode: service.itemCode,
										quantity:
											service.u_Modal == 'ort'
												? row.quantity *
													calculateKvm(
														row.width,
														row.height,
													)
												: service.isChizma ||
													  service.isShablonParametr
													? 1
													: service.u_Modal ===
																'Templete_Services' ||
														  service.u_Modal ===
																'Telefon'
														? service.itemQuantity *
															service.quantity
														: service.ugpName ===
																	'шт' &&
															  !service.isParametr
															? service.quantity *
																service.itemQuantity
															: service.ugpName ===
																		'шт' &&
																  service.isParametr
																? +service.u_ParametrQuantityValues *
																	+service.itemQuantity
																: service.ugpName ===
																			'м' &&
																	  !service.isParametr &&
																	  service.u_Modal !==
																			'Circle_Services'
																	? perimeterQuantity(
																			row.width,
																			row.height,
																			service.quantity,
																		)
																	: service.ugpName ===
																				'м' &&
																		  !service.isParametr &&
																		  service.u_Modal ===
																				'Circle_Services'
																		? circleServiceQuantity(
																				service.width,
																				service.itemQuantity,
																			)
																		: service.ugpName ===
																					'м' &&
																			  service.isParametr
																			? +service.quantity *
																				+service.u_ParametrQuantityValues *
																				service.itemQuantity
																			: Number(
																					+service.quantity *
																						calculateKvm(
																							row.width,
																							row.height,
																						),
																				),
										unitPrice:
											service.isChizma ||
											service.isShablonParametr
												? 0
												: Number(service.price),
										currency: service.currency,
										warehouseCode: whs,
										u_uslugaID: Number(service.lineNum),
										u_Produkt: row.itemName,
										u_Kvmetr: '',
										u_Timer: service.u_Timer,
										u_Width: row.width,
										u_Height: row.height,

										u_PlannedQuantity:
											service.u_Modal == 'ort' ||
											service?.u_Modal == 'Key_Figures' ||
											service?.u_Modal ===
												'Templete_Figures' ||
											service?.u_Modal == 'Telefon'
												? service.itemQuantity
												: service.isChizma
													? 1
													: service.ugpName === 'м' &&
														  service.isParametr
														? service.u_ParametrQuantityValues *
															row.quantity
														: (service.ugpName ===
																	'м' &&
																	!service.isParametr &&
																	service.u_Modal ==
																		'Circle_Services') ||
															  service.u_Modal ===
																	'Templete_Services' ||
															  (service.ugpName ===
																	'шт' &&
																	!service.isParametr)
															? service.itemQuantity
															: service.quantity,
										u_Coefficient:
											service.ugpName === 'шт' ||
											service.ugpName === 'м'
												? 1
												: row.koefitsent,
										u_Number: service.u_Number || '',
										u_ItemGroup: service.isChizma
											? 'Chizma'
											: service.isShablonParametr
												? 'ShablonShape'
												: service.isShablonService
													? 'ShablonService'
													: service.isParametr
														? 'Shape'
														: 'Service',
										u_ShapeSides: service.isParametr
											? service?.u_ShapeSides
											: '',
										u_SizeType: service.u_SizeType || '',
										u_SharepeningType:
											service.u_SharepeningType || '',
										u_ConnectedShape:
											service.isShablonService
												? row.selectedServices?.filter(
														(s) =>
															s.isShablonParametr,
													)?.map((s) => s.itemCode).join(',')
												: '',

										u_FigureQuantity: service.isParametr
											? service.u_ParametrQuantityValues
											: service.u_Modal ===
														'Templete_Services' ||
										      service?.u_Modal ===
														'Telefon' ||
										      (service.u_Modal ===
														'Key_Services' &&
														service.ugpName ===
															'шт') ||
										      (service.u_Modal ===
														'Circle_Services' &&
														service.ugpName ===
															'шт') // Bunda Key_Services va Circle_Services u_Modal bo'lsa sht ga yozgan quantity tushadi
												? service.quantity
												: 0,
										u_Modal: service.u_Modal || '',
										discountPercent:
											service?.u_Modal == 'ort' ? 100 : 0,
										u_ProductionNumber:
											service.u_ProductionNumber,
										u_ElectricityCost:
											service.U_Elektr_rasxod || 0,
										u_MachineCost:
											service.U_Stanok_rasxod || 0,
									})),
								)
								.sort((a, b) =>
									(a.u_Number || '').localeCompare(
										b.u_Number || '',
										undefined,
										{ numeric: true },
									),
								)
						: []),
				],
			}

			console.log('data', data)

			await http.post(
				`api/sales/sotuv-buyurtmasi?needToConfirmFromBot=${sendFile}`,
				data,
			)
			successRef.current.open(t('sucCreated'))
		} catch (error) {
			catchError(error, errorRef)
		} finally {
			setIsBtnLoading(false)
		}
	}

	const addRow = () => {
		const nextLineNum = tableData[tableData.length - 1].lineNum + 1
		setTableData([
			...tableData,
			{
				key: Date.now(),
				itemCode: null,
				itemName: null,
				width: '',
				height: '',
				quantity: '',
				ugpName: '',
				price: '',
				lineTotal: '',
				lineNum: nextLineNum,
				u_Timer: null,
				u_Number: null,
				koefitsent: 1,
				disabled: false,
				selectedServices: [
					{
						...defaultService,
						lineNum: nextLineNum,
					},
				],
				itemType: 'Item',
			},
		])
	}

	const copyRow = (record) => {
		const nextLineNum = tableData[tableData.length - 1].lineNum + 1
		setTableData([
			...tableData,
			{
				key: Date.now(),
				itemCode: record.itemCode,
				itemName: record.itemName,
				width: '',
				height: '',
				quantity: '',
				ugpName: '',
				currency: currency,
				price: record.price,
				lineTotal: '',
				lineNum: nextLineNum,
				u_Timer: record.u_Timer,
				u_Number: record.u_Number,
				koefitsent: record.koefitsent,
				disabled: record.disabled,
				selectedServices: [
					{
						...defaultService,
						lineNum: nextLineNum,
					},
				],
				itemType: record.itemType,
			},
		])
	}

	const removeRow = (key) => {
		if (tableData.length > 1) {
			setTableData(tableData.filter((row) => row.key !== key))
		}
	}

	const uploadImg = async (index) => {
		const image = imageList[index]

		if (!image.file) {
			message.error('Фотография не выбрано')
			return
		}

		const formData = new FormData()
		formData.append('file', image.file)

		const generateRandomKey = () => {
			const characters =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let randomKey = ''
			for (let i = 0; i < 16; i++) {
				randomKey += characters.charAt(
					Math.floor(Math.random() * characters.length),
				)
			}
			return randomKey
		}

		const randomKey = generateRandomKey()
		const title = 'YourTitle'

		formData.append('Title', title)
		formData.append('Key', randomKey)

		try {
			const updatedImageList = [...imageList]
			updatedImageList[index].imgLoading = true
			setImageList(updatedImageList)

			const res = await http.post('api/assets/upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})

			const { key } = res.data
			updatedImageList[index].path = key
			setImageList(updatedImageList)

			message.success('Успешно загружено!')
		} catch {
			message.error('Ошибка загрузки')
		} finally {
			const updatedImageList = [...imageList]
			updatedImageList[index].imgLoading = false
			setImageList(updatedImageList)
		}
	}

	const viewImage = async (index) => {
		const image = imageList[index]

		try {
			const res = await http.get(`api/assets/download/${image.path}`, {
				responseType: 'blob',
			})

			const url = window.URL.createObjectURL(
				new Blob([res.data], {
					type: 'image/png',
				}),
			)

			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'BP.png')
			document.body.appendChild(link)
			link.click()

			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch {
			message.error('Ошибка загрузки файла')
		}
	}

	const addNewRow = () => {
		setImageList([
			...imageList,
			{ file: null, path: '', imgLoading: false },
		])
	}

	const deleteRow = (index) => {
		setImageList(imageList.filter((_, i) => i !== index))
	}

	const handleDateChange = (e) => {
		const input = Number(e.target.value)
		setInputDateCount(input)

		if (!isNaN(input)) {
			let daysToAdd = input
			const newDate = moment()

			while (daysToAdd > 0) {
				newDate.add(1, 'days')
				if (newDate.day() !== 0) {
					daysToAdd--
				}
			}
			setDate(newDate.format('YYYY-MM-DD'))
		} else {
			console.error('Invalid input: Please input a valid number.')
		}
	}

	const handleFileChange = (event, index) => {
		const updatedImageList = [...imageList]
		updatedImageList[index].file = event.target.files[0]
		setImageList(updatedImageList)
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setSearchClientName)
	}

	const handleItemNameChange = (val) => {
		debouncedSet(val, setSearchItemName)
	}

	const handleKoefitsentChange = (value, itemName) => {
		setTableData((prevData) => {
			const koef = parseFloat(value) || 0
			return prevData.map((row) => {
				if (row.itemName === itemName) {
					// Update all grouped rows
					console.log('row', row)
					const selectedPrices = calculateKvmPrices(
						row?.selectedServices,
					)

					const shtPrices = calculateShtPrices(selectedServices)

					const totalWithKoef = calculateTotalWithKoef(
						row.width,
						row.height,
						row.quantity,
						koef,
					)

					// const lineTotal =
					// 	calculateLineTotal(
					// 		row.price,
					// 		selectedPrices,
					// 		totalWithKoef,
					// 	) + shtPrices

					const lineTotal = calculateLineTotal(
						row.price,
						0, //Endi Uslugalarni Narxini koefitsent bn hisoblanmidi
						totalWithKoef,
					)

					return {
						...row,
						koefitsent: koef, // Store updated coefficient
						// lineTotalWithKoef: totalWithKoef, // Recalculate total
						lineTotal, // Update calculated total
					}
				}
				return row
			})
		})
	}

	const handleModalYes = () => {
		setIsConfirmModalVisible(false)
		navigate('/sales-order')
	}

	const handleModalNo = () => {
		setIsConfirmModalVisible(false)
	}

	const handleModalCancel = () => {
		setIsConfirmModalVisible(false)
	}

	const summarizeTableData = (data) => {
		const groupedData = data.reduce((acc, record) => {
			const {
				itemName,
				width,
				height,
				quantity,
				koefitsent,
				amountInWhs,
				price,
			} = record
			const koef = koefitsent || 1
			const totalWithKoef = calculateTotalWithKoef(
				width,
				height,
				quantity,
				1,
			)

			if (!acc[itemName]) {
				acc[itemName] = {
					...record,
					lineTotalWithKoef: 0,
					lineTotal: 0,
					count: 0,
					amountInWhs,
					koefitsent,
				}
			}

			acc[itemName].lineTotalWithKoef += totalWithKoef
			acc[itemName].count += 1

			return acc
		}, {})

		return Object.values(groupedData).map((item, index) => ({
			...item,
			key: index,
		}))
	}

	const summarizedData = summarizeTableData(tableData)

	const totalPerimetrToM = tableData.reduce(
		(acc, curr) => {
			acc.height += curr.height / 1000
			acc.width += curr.width / 1000
			acc.quantity += curr.quantity
			return acc
		},
		{ height: 0, width: 0, quantity: 0 },
	)

	return (
		<Layout>
			<div className={'p-7'}>
				<ClientOrderInfoSection
					t={t}
					loadingClient={loadingClient}
					clientName={clientName}
					setClientName={setClientName}
					handleCardNameChange={handleCardNameChange}
					clientsData={clientsData}
					setClientCode={setClientCode}
					setIsModalVisible={setIsModalVisible}
					currency={currency}
					setCurrency={setCurrency}
					roleNames={roleNames}
					departmentAdmin={departmentAdmin}
					setDepartmentAdmin={setDepartmentAdmin}
					departmentLoading={departmentLoading}
					departmentData={departmentData}
					slpCode={slpCode}
					setSlpAdmin={setSlpAdmin}
					slpLoading={slpLoading}
					slpData={slpData}
					dateSale={dateSale}
					setDateSale={setDateSale}
					whs={whs}
					setWhs={setWhs}
					whsLoading={whsLoading}
					warehouseData={warehouseData}
					bpDebt={bpDebt}
					clientCode={clientCode}
					setIsViewBpBalanceModalVisible={
						setIsViewBpBalanceModalVisible
					}
				/>

				<SalesItemsTable
					t={t}
					tableData={tableData}
					setTableData={setTableData}
					itemsData={itemsData}
					itemsLoading={itemsLoading}
					whs={whs}
					handleItemNameChange={handleItemNameChange}
					setIsModalOpen={setIsModalOpen}
					setCurrentRecord={setCurrentRecord}
					setSelectedServices={setSelectedServices}
					addRow={addRow}
					copyRow={copyRow}
					removeRow={removeRow}
				/>

				<SummaryTable
					t={t}
					summarizedData={summarizedData}
					isAdmin={isAdmin}
					handleKoefitsentChange={handleKoefitsentChange}
					selectedServices={selectedServices}
				/>

				<OrderTotalsSection
					t={t}
					handleDateChange={handleDateChange}
					docTotal={docTotal}
					currency={currency}
					totalKvm={totalKvm}
					totalPerimetrToM={totalPerimetrToM}
					inputDocTotal={inputDocTotal}
					handleDocTotalBlur={handleDocTotalBlur}
					handleDocTotalChange={handleDocTotalChange}
					isDiscountBigger={isDiscountBigger}
					sendFile={sendFile}
					setSendFile={setSendFile}
					setComments={setComments}
				/>

				<ImageUploadSection
					t={t}
					imageList={imageList}
					handleFileChange={handleFileChange}
					uploadImg={uploadImg}
					viewImage={viewImage}
					deleteRow={deleteRow}
					addNewRow={addNewRow}
				/>

				<FormActions
					t={t}
					setIsConfirmModalVisible={setIsConfirmModalVisible}
					onSubmit={onSubmit}
					btnLoading={btnLoading}
					imageList={imageList}
				/>
			</div>

			<ServicesModal
				t={t}
				open={isModalOpen}
				currentRecord={currentRecord}
				selectedServices={selectedServices}
				setSelectedServices={setSelectedServices}
				tableData={tableData}
				setTableData={setTableData}
				setIsModalOpen={setIsModalOpen}
				packageServicesData={packageServicesData}
				serviceItemsData={serviceItemsData}
				rombikItemsData={rombikItemsData}
				telefonItemsData={telefonItemsData}
				kalitShapedData={kalitShapedData}
			/>

			<CreteCustomerModal
				visible={isModalVisible}
				data={null}
				onClose={() => {
					refetch()
					setIsModalVisible(false)
				}}
				onConfirm={(code) => {
					const data = `${code?.name} ${code?.phoneNumber ? code?.phoneNumber : ''}`
					setClientName(data)
					setClientCode(code?.cardCode)
				}}
			/>
			<ViewDepartmentsBalanceModal
				visible={isViewBpBalanceModalVisible}
				data={bpBalanceData[0]}
				onClose={() => {
					setIsViewBpBalanceModalVisible(false)
				}}
			/>

			<ConfirmExitModal
				visible={isConfirmModalVisible}
				handleClickCancel={handleModalCancel}
				handleClickNo={handleModalNo}
				handleClickYes={handleModalYes}
			/>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
				onConfirm={() => {
					navigate('/sales-order')
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<WarningModal
				getRef={(r) => {
					warningRef.current = r
				}}
			/>
		</Layout>
	)
}

export default CreateSales
